import { useCurrentUserContext } from '@contexts/current-user-context';

const useCurrentUser = () => {
  const { user } = useCurrentUserContext();

  return user;
};

export { useCurrentUser };
